import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { type FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { AzureEntraUserPicker } from './components/AzureEntraUserPicker/AzureEntraUserPicker';
import {
  AzureEntraUserPickerSchema,
  type AzureEntraUserPickerUiOptions,
  type AzureEntraUserPickerValue,
} from './components/AzureEntraUserPicker/schema';
import { InvoiceSectionPicker } from './components/InvoiceSectionPicker/InvoiceSectionPicker';
import {
  InvoiceSectionPickerSchema,
  type InvoiceSectionPickerUiOptions,
} from './components/InvoiceSectionPicker/schema';
import {
  FoundryModelPicker,
  validateFoundryModel,
} from './components/FoundryModelPicker/FoundryModelPicker';
import {
  FoundryModelPickerSchema,
  type FoundryModel,
  type FoundryModelPickerUiOptions,
} from './components/FoundryModelPicker/schema';
import { EntityDescription } from './components/EntityDescription/EntityDescription';
import {
  EntityDescriptionSchema,
  type EntityDescriptionUiOptions,
} from './components/EntityDescription/schema';
import {
  IpRangePicker,
  validateIpRange,
} from './components/IpRangePicker/IpRangePicker';
import {
  IpRangePickerSchema,
  type IpRangePickerUiOptions,
} from './components/IpRangePicker/schema';

const EntityDescriptionField = (
  props: FieldExtensionComponentProps<
    string | undefined,
    EntityDescriptionUiOptions
  >,
) => {
  return <EntityDescription {...props} />;
};

export const entityDescriptionFieldModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'EntityDescription',
      params: {
        field: async () =>
          createFormField({
            name: 'EntityDescription',
            component: EntityDescriptionField,
            schema: EntityDescriptionSchema as any,
          }),
      },
    }),
  ],
});

const AzureEntraUserPickerField = (
  props: FieldExtensionComponentProps<
    AzureEntraUserPickerValue | undefined,
    AzureEntraUserPickerUiOptions
  >,
) => {
  return <AzureEntraUserPicker {...props} />;
};

const InvoiceSectionPickerField = (
  props: FieldExtensionComponentProps<
    string | undefined,
    InvoiceSectionPickerUiOptions
  >,
) => {
  return <InvoiceSectionPicker {...props} />;
};

const FoundryModelPickerField = (
  props: FieldExtensionComponentProps<
    FoundryModel | undefined,
    FoundryModelPickerUiOptions
  >,
) => {
  return <FoundryModelPicker {...props} />;
};

const IpRangePickerField = (
  props: FieldExtensionComponentProps<
    string | undefined,
    IpRangePickerUiOptions
  >,
) => <IpRangePicker {...props} />;

export const ipRangePickerFieldModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'IpRangePicker',
      params: {
        field: async () =>
          createFormField({
            name: 'IpRangePicker',
            component: IpRangePickerField,
            schema: IpRangePickerSchema as any,
            validation: validateIpRange,
          }),
      },
    }),
  ],
});

export const foundryModelPickerFieldModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'FoundryModelPicker',
      params: {
        field: async () =>
          createFormField({
            name: 'FoundryModelPicker',
            component: FoundryModelPickerField,
            schema: FoundryModelPickerSchema as any,
            validation: validateFoundryModel,
          }),
      },
    }),
  ],
});

export const invoiceSectionPickerFieldModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'InvoiceSectionPicker',
      params: {
        field: async () =>
          createFormField({
            name: 'InvoiceSectionPicker',
            component: InvoiceSectionPickerField,
            schema: InvoiceSectionPickerSchema as any,
          }),
      },
    }),
  ],
});

export const azureEntraUserPickerFieldModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'AzureEntraUserPicker',
      params: {
        field: async () =>
          createFormField({
            name: 'AzureEntraUserPicker',
            component: AzureEntraUserPickerField,
            schema: AzureEntraUserPickerSchema as any,
          }),
      },
    }),
    FormFieldBlueprint.make({
      name: 'AzureGraphUserPickerField',
      params: {
        field: async () =>
          createFormField({
            name: 'AzureGraphUserPickerField',
            component: AzureEntraUserPickerField,
            schema: AzureEntraUserPickerSchema as any,
          }),
      },
    }),
  ],
});
